import AlphaHelpers from '../abstracts/classes/alpha-helpers'

document.addEventListener('DOMContentLoaded', () => {
  const noClickElements = AlphaHelpers.smartQuerySelectorAll('.menu-item-no-click')
  noClickElements.forEach((noClickEl) => {
    noClickEl.addEventListener('click', (e) => {
      const targetEl = e.target

      const parentMenuItem = e.target.closest('.menu-item')
      if (parentMenuItem) {
        const toggleElement = parentMenuItem.querySelector('.submenu-toggle')
        if (toggleElement) {
          toggleElement.click()
        }
      }

      if (targetEl === noClickEl || !targetEl.closest('.submenu-toggle') && !targetEl.closest('.submenu')) {
        e.preventDefault()
      }
    })
  })
})
